// Lightweight Ad Manager: dynamically loads AdSense script and initializes ads
const AdManager = (function () {
  let loaded = false;
  let loadingPromise = null;

  function loadAdSense(client) {
    if (loaded) return Promise.resolve();
    if (loadingPromise) return loadingPromise;

    loadingPromise = new Promise((resolve, reject) => {
      if (typeof document === 'undefined') return reject(new Error('No document'));

      const existing = document.querySelector(`script[data-adsbygoogle-client="${client}"]`);
      if (existing) {
        loaded = true;
        return resolve();
      }

      const s = document.createElement('script');
      s.async = true;
      s.setAttribute('data-adsbygoogle-client', client);
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
      s.crossOrigin = 'anonymous';
      s.onload = () => {
        loaded = true;
        // Initialize any existing ad containers
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
          // ignore
        }
        resolve();
      };
      s.onerror = (err) => reject(err || new Error('AdSense script failed to load'));
      document.head.appendChild(s);
    });

    return loadingPromise;
  }

  return {
    loadAdSense,
    isLoaded: () => loaded,
  };
})();

export default AdManager;
